import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/download_production/69e8f8fd63911b0014743bd3/oncoconsil/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/download_production/69e8f8fd63911b0014743bd3/oncoconsil/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/home/ubuntu/download_production/69e8f8fd63911b0014743bd3/oncoconsil/src/contexts/NotificationContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RoleProvider"] */ "/home/ubuntu/download_production/69e8f8fd63911b0014743bd3/oncoconsil/src/contexts/RoleContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69e8f8fd63911b0014743bd3/oncoconsil/src/styles/tailwind.css");
